import axios from '@/service';
import { redirectToPanelV4ForUser } from '@/utils/panelV4';

const AuthService = {
  login(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('auth/login', payload)
        .then((res) => {
          this.setLocalStorage(res.data);
          resolve(res);
        })
        .catch((err) => {
          this.clearLocalStorage();
          reject(err);
        });
    });
  },
  register(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('auth/register', payload)
        .then((res) => {
          this.login({
            email: payload.user.email,
            password: payload.user.password,
          })
            .then(() => {
              if (redirectToPanelV4ForUser()) return;

              window.location = import.meta.env.VITE_URL;
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  me() {
    return new Promise((resolve, reject) => {
      axios
        .post('auth/me')
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  logout() {
    return new Promise((resolve) => {
      this.clearLocalStorage();
      resolve(true);
    });
  },
  restoreSuperSession() {
    const token = localStorage.getItem(`${import.meta.env.VITE_NAME}.super.token`);
    const user = JSON.parse(
      localStorage.getItem(`${import.meta.env.VITE_NAME}.super.user`) || '{}'
    );

    if (!token || user?.type !== 'super') {
      return false;
    }

    localStorage.setItem(`${import.meta.env.VITE_NAME}.token`, token);
    localStorage.setItem(
      `${import.meta.env.VITE_NAME}.user`,
      JSON.stringify(user)
    );
    localStorage.removeItem(`${import.meta.env.VITE_NAME}.login_adm`);
    localStorage.removeItem(`${import.meta.env.VITE_NAME}.companyIdLogged`);
    localStorage.removeItem(`${import.meta.env.VITE_NAME}.companiesByCustomer`);
    localStorage.removeItem(`${import.meta.env.VITE_NAME}.companySetting`);

    return true;
  },
  setLocalStorage(data) {
    const { token, user, login_adm } = data;
    localStorage.setItem(`${import.meta.env.VITE_NAME}.token`, token);
    localStorage.setItem(
      `${import.meta.env.VITE_NAME}.user`,
      JSON.stringify(user)
    );
    if (user.company?.id) {
      localStorage.setItem(
        `${import.meta.env.VITE_NAME}.companyIdLogged`,
        user.company.id
      );
    }

    const companies = (user.customer?.companies || []).map((company) => {
      return {
        id: company.id,
        name: company.name,
      };
    });
    localStorage.setItem(
      `${import.meta.env.VITE_NAME}.companiesByCustomer`,
      JSON.stringify(companies)
    );

    if (login_adm) {
      localStorage.setItem(`${import.meta.env.VITE_NAME}.login_adm`, 'true');
    } else {
      localStorage.removeItem(`${import.meta.env.VITE_NAME}.login_adm`);
    }

    if (user.type === 'super') {
      localStorage.setItem(`${import.meta.env.VITE_NAME}.super.token`, token);
      localStorage.setItem(
        `${import.meta.env.VITE_NAME}.super.user`,
        JSON.stringify(user)
      );
    }
  },
  clearLocalStorage() {
    localStorage.removeItem(`${import.meta.env.VITE_NAME}.token`);
    localStorage.removeItem(`${import.meta.env.VITE_NAME}.user`);
    localStorage.removeItem(`${import.meta.env.VITE_NAME}.companyIdLogged`);
    localStorage.removeItem(`${import.meta.env.VITE_NAME}.companiesByCustomer`);
    localStorage.removeItem(`${import.meta.env.VITE_NAME}.companySetting`);
    localStorage.removeItem(`${import.meta.env.VITE_NAME}.super.token`);
    localStorage.removeItem(`${import.meta.env.VITE_NAME}.super.user`);
    localStorage.removeItem(`${import.meta.env.VITE_NAME}.login_adm`);
  },
};

export default AuthService;
